export const T = {
  en_GB: { addTeam: "Add Team" },
  nb_NO: { addTeam: "Legg til team" },
} as const;
